import React from 'react';
import '../styles/App.css';
import { useDispatch, connect } from 'react-redux';
import MainNavbar from './layout/MainNavbar';
import Main from './layout/Main';
import Register from './page/Auth/Register'
import Login from './page/Auth/Login'
import Battery from './page/zzzPracticeTestPages/Battery';
import { useHistory, BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import ErrorHandlerAlert from './error/ErrorHandlerAlert';
import Corporate from './page/BatteryPages/Corporate';
import ManageConsignments from './page/ConsignmentPages/ManageConsignments';
import ManageUsersConsignments from './page/ConsignmentPages/ManageUsersConsignments';
import InventoryCountEdit from './page/ConsignmentPages/InventoryCountEdit';
import { ability, defineRulesFor } from '../config/ability';
import UserManagement from './page/SettingsPages/UserManagement';
import MainHeader from './layout/MainHeader';
import InvoiceLayout from './layout/InvoiceLayout';
import NavbarFMP from './layout/NavbarFMP';
import { MediaQuery } from 'react-responsive'

function App(props) {
  //const isLogged = useSelector(state => state.isLogged);  //EXAMPLE ON HOW TO USE useSelector from react-redux --> state.isLogged was the name of the state in reduxc/index.js (has been deleted)
  const history = useHistory();
  const dispatch = useDispatch();

  const { authreducer } = props;
  if(typeof(authreducer.user) !== 'undefined'){
    ability.update(defineRulesFor(authreducer.user));
  }

  return (
    <div className="App">

      <Router>
        <Switch>

          {/* REGISTER PAGE UNNEEDED AT THIS TIME */}
          {/* <Route exact path='/register'>
            <ErrorHandlerAlert/>
            <Register />
          </Route>   */}


          <Route exact path='/login'>
            <ErrorHandlerAlert/>
            <Login/>
          </Route>

          {authreducer.user.role_name === undefined || !authreducer.isLoggedIn ?
          (
              // <React.Fragment>
              //   <ErrorHandlerAlert/>
              //   <Login/>
              // </React.Fragment>
            <React.Fragment>
              <Redirect to="/login" />
            </React.Fragment>

          ) :
          (
            <React.Fragment>

              <Route exact path='/invoices'>
                <MainNavbar />
                <InvoiceLayout/>
              </Route>

              {/* {authreducer.user.login_type === 'AD' ?
                (<Route exact path='/consignments'>
                  <NavbarFMP />
                  <ManageConsignments/>
                </Route>
                ) : ''
              } */}

              {/* <Route exact path='/battery'>
                <MainNavbar />
                <Battery/>
              </Route>

              <Route exact path='/battery/corporate'>
                <MainNavbar />
                <Corporate/>
              </Route>   */}

              {
                authreducer.user.login_type === 'AD' ? (
                  <Route exact path='/manageUsersConsignments'>
                      <MediaQuery minDeviceWidth={768}>
                        <NavbarFMP />
                        <ManageUsersConsignments/> 
                      </MediaQuery> 

                      {/* tablet or mobile phone */}
                      <MediaQuery maxDeviceWidth={767} maxDeviceHeight={940}>
                        <div className="mainWrapper">                    
                          <ManageUsersConsignments/>
                          <NavbarFMP />
                        </div>
                      </MediaQuery>                    
                  </Route>
                ) : (
                  ''
                )
              }


              <Route exact path='/'>
                {
                  authreducer.user.login_type === 'AD' ?  (
                    <React.Fragment>
                      <MediaQuery minDeviceWidth={768}>
                        <NavbarFMP />
                        <ManageConsignments/>  
                      </MediaQuery> 

                      {/* tablet or mobile phone */}
                      <MediaQuery maxDeviceWidth={767} maxDeviceHeight={940}>
                        <div className="mainWrapper">
                          <ManageConsignments/> 
                          <NavbarFMP />                        
                        </div>

                      </MediaQuery>
                                        
                    </React.Fragment>
                  ) :
                  authreducer.user.role_name !== 'ADMIN' ? (
                    <React.Fragment>
                      <ErrorHandlerAlert/>
                      <MainNavbar />
                      <Main/>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <MainNavbar />
                      {/* <UserManagement />  //OLD REMOVE */}
                      {/* <ManageConsignments/> */}
                    </React.Fragment>
                  )
                }
              </Route>

            </React.Fragment>
          )}
        </Switch>
      </Router>



    </div>

  );
}

const mapStateToProps = (state) => {
 return {
   authreducer: state.authreducer

 }

};

const mapDispatchToProps = (dispatch) => {
  return {

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
